/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_Tab_GrantInputs */

const en_admin_credits_tab_grant = /** @type {(inputs: Admin_Credits_Tab_GrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grant`)
};

/**
* | output |
* | --- |
* | "Grant" |
*
* @param {Admin_Credits_Tab_GrantInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_credits_tab_grant = /** @type {((inputs?: Admin_Credits_Tab_GrantInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_Tab_GrantInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_credits_tab_grant(inputs)
});
export { admin_credits_tab_grant as "admin.credits.tab_grant" }